/**
 * Payment-related error codes from backend responses.
 */
const PAYMENT_ERROR_CODES = new Set([
    'GCA_ACTION_REQUIRED',
    'REQUIRES_ADDITIONAL_PAYMENT_CONFIRMATION',
    'PaymentAuthenticationFailedException',
    'UnsupportedPaymentAuthenticationException',
]);
export const isPaymentError = (errorCode) => {
    return !!errorCode && PAYMENT_ERROR_CODES.has(errorCode);
};
